module.exports = __webpack_public_path__ + "static/img/Port-Adelaide.879610e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Port-Adelaide.jpg
// module id = mh08
// module chunks = 1